export const appLanguages = {
  en: 'en',
  de: 'de',
  fr: 'fr',
  ar: 'ar',
}

export const appLanguagesLocalStoreKey = 'appLanguages'
export const isUserEmailVerifiedKey = 'isUserEmailVerified'

export const appLanguagesList = [
  { value: appLanguages.en, title: 'En' },
  { value: appLanguages.de, title: 'De' },
  { value: appLanguages.fr, title: 'Fr' },
  { value: appLanguages.ar, title: 'Ar' },
]
